import React from 'react'
import { connect } from 'react-redux'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import Panel from 'muicss/lib/react/panel'
import Avatar from 'material-ui/Avatar'
import ListItem from 'material-ui/List/ListItem'
import FontAwesome from 'react-fontawesome'
import MissionAdvance from './MissionAdvance'
import Wrongs from './Wrongs'

const styles = {
  root: {
    padding: '0px',
  },
  header: {
    backgroundColor: '#F58A15',
    color: 'white',
  },
  headerImage: {
    height: '50px',
    width: 'auto',
  },
  description: {
    padding: '10px',
    paddingBottom: '30px',
  },
  experience: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderRight: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  credits: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderLeft: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  icons: {
    marginRight: '5px',
    fontSize: '16px',
  },
}


class PreMissionShow extends React.Component {


  render() {
    const { name, image_url, description, credits, experience } = this.props
    return (
      <Panel className="modal-panel" style={styles.root}>
        <Container fluid >
          <Row style={styles.header}>
            <ListItem
              style={styles.header}
              disabled
              leftAvatar={
                <Avatar src={image_url} />
            }
            >
              {name}
            </ListItem>
          </Row>
          <Row style={styles.description}>
            <h4>Descripción</h4>
            {description}
          </Row>
          <Row>
            <MissionAdvance />
          </Row>
          <Row>
            <Wrongs />
          </Row>
          <br />
          <Row>
            <Col xs="6" md="6" style={styles.experience}>
              <FontAwesome name="star" />
              {` ${experience}`}
            </Col>
            <Col xs="6" md="6" style={styles.credits}>
              <FontAwesome name="diamond" />
              {` ${credits}`}
            </Col>
          </Row>
        </Container>
      </Panel>
    )
  }
}

PreMissionShow.propTypes = {
  name: React.PropTypes.string,
  image_url: React.PropTypes.string,
  description: React.PropTypes.string,
  credits: React.PropTypes.number,
  experience: React.PropTypes.number,
}


const mapStateToProps = state => ({
  ...state.missions.selectedMission,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(PreMissionShow)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/SummaryMission/index.jsx